// removed by extract-text-webpack-plugin
module.exports = {"brandLogos":"BrandLogos__brandLogos","logo":"BrandLogos__logo"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BrandLogos/BrandLogos.scss
// module id = 1843
// module chunks = 0